import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_CURRENT_AFFAIRS: MijnRoute = {
    path: 'openstaande-acties',
    navigationEvent: 'toOpenstaandeActies',
    regex: /^\/zelf-regelen\/openstaande-acties$/,
    webcomponent: 'mijn-klant-lopende-zaken-webcomponent'
};
